import { useEffect, useState } from 'react';

import { useGTM } from '@/features/Analytics';
import type { PageType } from '@/features/Analytics';

import { useBooking } from '../store/booking';

import type { IPayloadMakeBooking } from '@/entities/booking/model/types';

interface UseGABookingProps {
  makeBookingData: IPayloadMakeBooking;
  medcenterName: string;
  doctorName: string;
  pageType: PageType;
  doctorId: number;
  referral: string;
}

interface UseGABookingHook {
  trackErrorBookingModal: (msg: string) => void;
  trackOTPEvents: (eventName: string) => void;
  trackOpenBookingModal: () => void;
}

export const useGABooking = (props: UseGABookingProps): UseGABookingHook => {
  const { makeBookingData, doctorId, medcenterName, doctorName, pageType } = props;

  const { booking } = useBooking();
  const { trackEvent } = useGTM(pageType);

  const [currentBooking, setCurrentBooking] = useState(booking.find(item => item.doctorId === doctorId));

  const buildGAPayload = () => {
    return {
      medcenterName,
      doctorName,
    };
  };

  const trackErrorBookingModal = (msg: string) => {
    trackEvent('error_simple_booking', {
      error_message: msg,
      ...buildGAPayload(),
    });
  };

  const trackOTPEvents = (eventName: string) => {
    trackEvent(eventName, {
      formData: `тип записи: ${makeBookingData.bookingType}, желаемое время: ${makeBookingData.preferredTime}, номер: ${makeBookingData.phoneNumber}, ИИН: ${makeBookingData.iin}`,
      ...buildGAPayload(),
    });
  };

  const trackOpenBookingModal = () => {
    trackEvent('open_booking_modal', {
      timeslot: currentBooking?.changedSlot ? 'on' : 'off',
      ...buildGAPayload(),
    });
  };

  useEffect(() => {
    setCurrentBooking(booking.find(item => item.doctorId === doctorId));
  }, [booking, doctorId]);

  return {
    trackErrorBookingModal,
    trackOTPEvents,
    trackOpenBookingModal,
  };
};
